module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-1-d166188c53cf5f4a8e2c0f004ca84af8.svg";